/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import VueCompositionAPI from '@vue/composition-api';
import _TagInput from './tag-input.js';
import { withInstall } from '../utils/withInstall.js';
import './style/css.js';
import './type.js';
import '../_chunks/dep-115a1bd3.js';
import '@babel/runtime/helpers/slicedToArray';
import '@babel/runtime/helpers/defineProperty';
import 'tdesign-icons-vue';
import '../input/index.js';
import '../input/input.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/typeof';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../config-provider/config-receiver.js';
import 'vue';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';
import '../utils/mixins.js';
import '../utils/event.js';
import '../input/props.js';
import '../utils/render-tnode.js';
import '../input/input-group.js';
import '../utils/map-props.js';
import '../input/type.js';
import 'lodash/capitalize';
import './props.js';
import '../config.js';
import './hooks/useTagScroll.js';
import './useTagList.js';
import '../tag/index.js';
import '../tag/tag.js';
import '../tag/props.js';
import '../tag/check-tag.js';
import '../tag/check-tag-props.js';
import '../tag/type.js';
import '../hooks/useVModel.js';
import '../hooks/tnode.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import '../hooks/render-tnode.js';
import 'lodash/isString';
import 'lodash/isObject';
import '../config-provider/useConfig.js';
import './hooks/useHover.js';
import '../hooks/useDefaultValue.js';
import './hooks/useDragSorter.js';
import '../hooks/useGlobalIcon.js';
import '../hooks/useConfig.js';

var TagInput = withInstall(_TagInput, VueCompositionAPI);

export { TagInput, TagInput as default };
//# sourceMappingURL=index.js.map
